import React from "react";
import colors from "../theme/colors";
import radius from "../theme/radius";
import typography from "../theme/typography";

const formFieldColors = {
  border: colors.border,
  inputBg: colors.surface,
  inputText: colors.textSecondary,
  text: colors.textPrimary,
  textDark: colors.textSecondary,
};

const inputBaseStyle = {
  width: "100%",
  minHeight: 46,
  borderRadius: radius.sm,
  border: `1.5px solid ${formFieldColors.border}`,
  background: formFieldColors.inputBg,
  padding: "0 14px",
  fontFamily: typography.fontFamily,
  fontSize: typography.size.sm,
  fontWeight: typography.weight.medium,
  color: formFieldColors.inputText,
  outline: "none",
  boxSizing: "border-box",
};

const selectBaseStyle = {
  ...inputBaseStyle,
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  paddingRight: 42,
};

const labelStyle = {
  display: "block",
  marginBottom: 6,
  fontFamily: typography.fontFamily,
  fontSize: typography.size.xs,
  fontWeight: typography.weight.bold,
  lineHeight: typography.lineHeight.tight,
  color: formFieldColors.textDark,
};

const helperTextStyle = {
  margin: 0,
  marginTop: 6,
  fontFamily: typography.fontFamily,
  fontSize: "11px",
  lineHeight: "15px",
  color: formFieldColors.textDark,
};

const readOnlyValueStyle = {
  margin: 0,
  fontFamily: typography.fontFamily,
  fontSize: typography.size.sm,
  fontWeight: typography.weight.semibold,
  lineHeight: typography.lineHeight.sm,
  color: formFieldColors.text,
};

const readOnlyFieldStyle = {
  paddingBottom: 12,
  borderBottom: `1px solid ${formFieldColors.border}`,
};

function formatReadOnlyValue(value, suffix = "") {
  if (value === null || value === undefined || value === "") {
    return "Não informado";
  }

  return `${value}${suffix}`;
}

export default function FormField({
  label,
  helperText = "",
  isEditing = true,
  readOnlyValue,
  readOnlySuffix = "",
  children,
  htmlFor,
  style = {},
  contentStyle = {},
  className = "",
  preserveSpacingWhenReadonly = false,
}) {
  const wrapperStyle = isEditing
    ? style
    : preserveSpacingWhenReadonly
      ? style
      : { ...readOnlyFieldStyle, ...style };

  return (
    <div className={className} style={wrapperStyle}>
      {label ? (
        <label htmlFor={htmlFor} style={labelStyle}>
          {label}
        </label>
      ) : null}

      <div style={contentStyle}>
        {isEditing ? (
          children
        ) : (
          <p style={readOnlyValueStyle}>
            {formatReadOnlyValue(readOnlyValue, readOnlySuffix)}
          </p>
        )}
      </div>

      {helperText ? <p style={helperTextStyle}>{helperText}</p> : null}
    </div>
  );
}

export {
  inputBaseStyle,
  selectBaseStyle,
  labelStyle,
  helperTextStyle,
  readOnlyValueStyle,
};